export function gallery() {
    const gallery = $(".gallery");
    const slider = gallery.find(".big-image");
    const thumbnails = gallery.find(".thumbnails");
    const thumbsNum = gallery.data("thumbs");
    const rtl = this.rtl;

    thumbnails.slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: slider,
        arrows: false,
        focusOnSelect: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 1600,
                settings: {
                    slidesToShow: thumbsNum
                }
            }
        ],
        rtl
    });

    slider.slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: thumbnails,
        rtl
    });
}




// WEBPACK FOOTER //
// ./assets/js/modules/gallery.js